var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53011 5.00033L6.19678 3.33366M6.19678 3.33366L4.53011 1.66699M6.19678 3.33366H4.53011C2.68916 3.33366 1.19678 4.82604 1.19678 6.66699M14.5301 15.0003L12.8634 16.667M12.8634 16.667L14.5301 18.3337M12.8634 16.667H14.5301C16.3711 16.667 17.8634 15.1746 17.8634 13.3337M10.7111 11.1813C11.363 11.4927 12.0928 11.667 12.8634 11.667C15.6249 11.667 17.8634 9.42842 17.8634 6.66699C17.8634 3.90557 15.6249 1.66699 12.8634 1.66699C10.102 1.66699 7.86344 3.90557 7.86344 6.66699C7.86344 7.43759 8.03777 8.16747 8.34913 8.81935M11.1968 13.3337C11.1968 16.0951 8.9582 18.3337 6.19678 18.3337C3.43535 18.3337 1.19678 16.0951 1.19678 13.3337C1.19678 10.5722 3.43535 8.33366 6.19678 8.33366C8.9582 8.33366 11.1968 10.5722 11.1968 13.3337Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.a8dda389a9fb5a0190d87d1549998278.svg";
export { ForwardRef as ReactComponent };